var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCrosshair(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12,1C5.929,1 1,5.929 1,12C1,18.071 5.929,23 12,23C18.071,23 23,18.071 23,12C23,12 23,11.964 23,11.964C22.998,11.52 22.971,11.076 22.916,10.634C22.823,9.889 22.654,9.153 22.411,8.442C22.144,7.662 21.789,6.913 21.354,6.213C20.907,5.492 20.377,4.823 19.777,4.223C19.177,3.623 18.508,3.093 17.787,2.646C17.087,2.211 16.338,1.856 15.558,1.589C14.836,1.342 14.089,1.171 13.331,1.08C12.89,1.027 12.445,1.001 12,1ZM13,3.055L13,6C13,6.552 12.552,7 12,7C11.448,7 11,6.552 11,6L11,3.055C6.831,3.516 3.517,6.831 3.055,11L6,11C6.552,11 7,11.448 7,12C7,12.552 6.552,13 6,13L3.055,13C3.516,17.169 6.831,20.483 11,20.945L11,18C11,17.448 11.448,17 12,17C12.552,17 13,17.448 13,18L13,20.945C17.169,20.484 20.483,17.169 20.945,13L18,13C17.448,13 17,12.552 17,12C17,11.448 17.448,11 18,11L20.945,11C20.484,6.831 17.169,3.517 13,3.055Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrosshair);
export default __webpack_public_path__ + "static/media/crosshair.dd422401.svg";
export { ForwardRef as ReactComponent };